var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[_c('div',{staticClass:"card",style:({ borderBottomColor: _vm.color })},_vm._l((_vm.info),function(item){return _c('p',{key:item.id},[_c('b',[_vm._v(_vm._s(item.label))]),_vm._v(" "+_vm._s(item.value)+" ")])}),0)]):_c('div',[_c('skeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }